/**
*
* Text
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
const fontFamily = '"Noto IKEA", "Noto Sans", "Noto Sans KR", "Noto Sans JP", "Noto Sans TC", "Noto Sans SC", "Noto Sans HK", "Roboto", "Open Sans", "sans-serif"';
import { useIntl } from 'react-intl';
import Text from "@ingka/text";
import '@ingka/text/dist/style.css';
import { colors } from 'ui/constants';

const toParagraphs = (...nodes) => {
  let key = 0;
  const children = nodes.reduce((result, node) => (
      result.concat(
          typeof node === 'string'
              ? node
                .split('\n')
                .map((paragraph) => <p key={++key}>{paragraph}</p>) // eslint-disable-line no-plusplus
              : node
      )
  ), []);

  return <span>{children}</span>;
};

const i18n = (text, theme, multiline) => {
  if (typeof text === 'object') {
    // if (theme.debug) {
    //   if (theme.debug.translationMode === 'keys') {
    //     return text.id;
    //   } else if (theme.debug.translationMode === 'master') {
    //     return text.defaultMessage;
    //   }
    // }

    if (multiline) {
      return <FormattedMessage key={text.id} {...text}>{toParagraphs}</FormattedMessage>;
    } else {
      return <FormattedMessage key={text.id} {...text} />;
    }
  } else {
    return text;
  }
};

const getChildren = (text, theme, multiline) => {
  if (text === null) return null;

  if (Array.isArray(text)) {
    return text.map((t) => i18n(t, theme));
  }

  return i18n(text, theme, multiline);
};

export const MyTestDiv = styled.div.attrs(props => (console.log("props isss: ", props)))`
    /* stylelint-disable declaration-block-no-duplicate-properties */
    ${(props) => props.bold ? 'font-weight: bold;' : ''}
    ${(props) => props.inline ? 'display: inline;' : ''}
    ${(props) => props.uppercase ? 'text-transform: uppercase;' : ''}
    @media print {
      font-family: ${fontFamily};
    }
    /* stylelint-enable */
  `;

export const CustomText = (props) => {
  const rest = props.restValue;
  return (
    // <div style={{
    //   display: props.inline ? "inline" : '', 
    //   color: props.color ? props.color : '',
    //   textTransform: props.uppercase ? "uppercase" : '',
    //   rest,
    //   margin: props.margin,
    //   lineHeight: props.lineHeight ? props.lineHeight : '16px',
    //   paddingRight: props.paddingRight ? props.paddingRight : '',
    //   paddingLeft: props.paddingLeft ? props.paddingLeft : ''
    //   }}>
      <Text
        tagName={props.tagName ? props.tagName : 'p'} 
        bodySize={props.bodySize ? props.bodySize : 'm'}
        headingSize={props.tagName === 'p' ? '' : props.headingSize ? props.headingSize : 'm'}
        bold={props.bold}
        underline={props.underline}
        props={props}
        
      >
        {!!props && !!props.text && getChildren(props.text, props.multiline)}
      </Text>
    // </div>
  )
};

export const NormalText = (props) =>  {
  return CustomText({
    color: props.color,
    tagName: props.tagName ? props.tagName : 'p', //'span'
    bodySize: props.bodySize ? props.bodySize : 'm',
    underline: props.underline ? props.underline : false, 
    ...props
})
};


export const HeadLine = (props) =>  {
  return NormalText({
    color: colors.heading,
    tagName: props.tagName ? props.tagName : 'h2', //'h1' etc.
    headingSize: props.headingSize ? props.headingSize : 'm',
    bold: props.bold ? props.bold : false,
    ...props
})
};

export const Signature = (props) =>  {
  return NormalText({
    tagName: props.tagName ? props.tagName : 'p',
    bodySize: props.bodySize ? props.bodySize : 'l',
    bold: true,
    ...props
    
})
};

export const SmallText = (props) =>  {
  return NormalText({
    tagName: 'p',
    bodySize: props.bodySize ? props.bodySize : 's',
    underline: props.underline ? props.underline : false, 
    ...props
})
};

export const textShape = PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.array]);

// supports both react-intl and plain text (already translated elsewhere)
function SkapaText({ custom, headline, small, signature, ...props }) {
  if (headline) {
    return HeadLine({...props});
  }

  if (signature) {
    return Signature({...props});
  }

  if (small) {
    return SmallText({...props});
  }

  if (custom) {
    return <CustomText {...props} />;
  }

  return <NormalText {...props} />;
}

SkapaText.propTypes = {
  bold: PropTypes.bool,
  underline: PropTypes.bool,
  inline: PropTypes.bool,
  uppercase: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  color: PropTypes.string,
  headline: PropTypes.bool,
  signature: PropTypes.bool,
  small: PropTypes.bool,
  custom: PropTypes.bool,
  // text: textShape,
};

SkapaText.defaultProps = {
  bold: false,
  underline: false,
  inline: false,
  uppercase: false,
  color: undefined,
  headline: false,
  signature: false,
  small: false,
  custom: false,
  // text: undefined,
};

export default SkapaText;
